
import { getEmployee } from '@/api/employee';
import { useEffect, useState } from 'react';

// {
//     "employee": {
//       "id": 1,
//       "fullname": "admin",
//       "collectedAmount": 0
//     },
//     "collection": {
//     "dailyStats": [],
//     "weeklyStats": [],
//     "monthlyStats": [
//       {
//         "_count": {
//           "_all": 2
//         },
//         "status": "Awaiting Collection"
//       },
//       {
//         "_count": {
//           "_all": 1
//         },
//         "status": "Payment Deposited"
//       }
//     ]
//   }
//   }
type EmployeeDetails = {
    employee: {
        id: number;
        fullname: string;
        collectedAmount: number;
    }
    transactions: Array<any>;
    collection: {
        dailyStats: Array<{
            _count: {
                _all: number;
            };
            status: string;
        }>;
        weeklyStats: Array<{
            _count: {
                _all: number;
            };
            status: string;
        }>;
        monthlyStats: Array<{
            _count: {
                _all: number;
            };
            status: string;
        }>;
    }

}
const useEmployeeById = (id: string) => {
    const [employee, setEmployee] = useState<EmployeeDetails | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEmployee = async () => {
            try {
                // Make an API call to fetch Clients
                const response = await getEmployee(id);

                setEmployee(response);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching client:', error);
                setLoading(false);
            }
        };

        fetchEmployee();
    }, [id]);

    return { ...employee, loading };
};

export default useEmployeeById;
